import Store from 'redux/store';
import { FETCH_EXTRACT_SUCCESS, FETCH_EXTRACT_FAIL, FETCH_EXTRACT } from 'redux/Reducers/Extract/Reducer';
import {
  FETCH_EXTRACT_TOTALIZERS, FETCH_EXTRACT_TOTALIZERS_FAIL,
  FETCH_EXTRACT_TOTALIZERS_SUCCESS,
} from 'redux/Reducers/Extract/TotalizersReducer';
import {
  FETCH_CREDIT_TO_EXPIRE, FETCH_CREDIT_TO_EXPIRE_FAIL,
  FETCH_CREDIT_TO_EXPIRE_SUCCESS,
} from 'redux/Reducers/Extract/CreditToExpireReducer';
import {
  FETCH_CAMPAIGN_NAME, FETCH_CAMPAIGN_NAME_FAIL,
  FETCH_CAMPAIGN_NAME_SUCCESS,
} from 'redux/Reducers/Extract/CampaignNameReducer';
import {
  FETCH_POINTS_EXPIRE, FETCH_POINTS_EXPIRE_FAIL,
  FETCH_POINTS_EXPIRE_SUCCESS,
} from 'redux/Reducers/Extract/PointsExpireReducer';
import { cloudloyalty } from '../clients';

/* eslint-disable */
export const FetchExtract = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_EXTRACT });
  cloudloyalty(User).get('/v1/participants/me/extractOrderDescription').then((response) => {
    Store.dispatch({
      type: FETCH_EXTRACT_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_EXTRACT_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchExtractWithFilter = async (User, finallyCallback = () => {}, { startDate, endDate }) => {
  Store.dispatch({ type: FETCH_EXTRACT });
  cloudloyalty(User).get(`/v1/participants/me/extractOrderDescription?startDate=${startDate}&endDate=${endDate}`).then((response) => {
    Store.dispatch({
      type: FETCH_EXTRACT_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_EXTRACT_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchExtractTotalizer = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_EXTRACT_TOTALIZERS });
  cloudloyalty(User).get('/v1/participants/me/extract').then((response) => {
    Store.dispatch({
      type: FETCH_EXTRACT_TOTALIZERS_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_EXTRACT_TOTALIZERS_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchCreditToExpire = async (User, finallyCallback = () => {}, payload = {}) => {
  Store.dispatch({ type: FETCH_CREDIT_TO_EXPIRE });
  cloudloyalty(User).get(`/v1/participants/me/toExpire/${payload.periodId}`).then((response) => {
    Store.dispatch({
      type: FETCH_CREDIT_TO_EXPIRE_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_CREDIT_TO_EXPIRE_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchCampaignName = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_CAMPAIGN_NAME });
  cloudloyalty(User).get('/v1/participants/me/fullBalance').then((response) => {
    Store.dispatch({
      type: FETCH_CAMPAIGN_NAME_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_CAMPAIGN_NAME_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchPointsToExpire = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_POINTS_EXPIRE });
  cloudloyalty(User).get('/v1/participants/me/consolidatedPointsToExpire').then((response) => {
    Store.dispatch({
      type: FETCH_POINTS_EXPIRE_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_POINTS_EXPIRE_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};
